module.exports = __webpack_public_path__ + "static/xceltoken (1)-fc063c3ab799bdaccdc1b3b155d2ee18.png";